var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalcony(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5556 18.8V22H15.1111V18.8H18.5556ZM28.8889 22V18.8H25.4444V22H28.8889ZM37.5 25.2V38H6.5V25.2H8.22222V18.8C8.22222 11.728 14.3878 6 22 6C29.6122 6 35.7778 11.728 35.7778 18.8V25.2H37.5ZM13.3889 28.4H9.94444V34.8H13.3889V28.4ZM20.2778 28.4H16.8333V34.8H20.2778V28.4ZM20.2778 9.328C15.3867 10.096 11.6667 14.048 11.6667 18.8V25.2H20.2778V9.328ZM23.7222 25.2H32.3333V18.8C32.3333 14.048 28.6133 10.096 23.7222 9.328V25.2ZM27.1667 28.4H23.7222V34.8H27.1667V28.4ZM34.0556 28.4H30.6111V34.8H34.0556V28.4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalcony);
export default __webpack_public_path__ + "static/media/balcony.fbf69789eabd58eabd8a0bc132064bf8.svg";
export { ForwardRef as ReactComponent };